import { useCrmSelection_AllInvestorFirmsMappedToCmgEntityKeyQuery } from '../graphql/__generated__';

export const useGetAllInvestorFirmsMappedToCmgEntityKey = (
  options: Parameters<typeof useCrmSelection_AllInvestorFirmsMappedToCmgEntityKeyQuery>[0]
) =>
  useCrmSelection_AllInvestorFirmsMappedToCmgEntityKeyQuery({
    ...options,
    fetchPolicy: 'no-cache',
  });
